import { TransportationTypeIcon } from '@/components/icons/TransportationTypeIcon';
import type { LegInfo } from '@/hooks/useSeatSelectionLegs';
import { TransText } from '@/i18n/trans/text';
import { cn } from '@/utils/cn';
import { Icons, Radio, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface LegSelectionItemProps {
  leg: LegInfo;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export const LegSelectionItem: FC<LegSelectionItemProps> = ({
  leg,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      className={cn(
        'flex h-12 w-full items-center rounded-md border border-neutral px-3 py-2 hover:cursor-pointer hover:bg-primary-pale',
        {
          'border-primary bg-primary-light': isSelected,
          'pointer-events-none border-neutral-light bg-greyscale-100 text-neutral':
            leg.noSeatSelection,
        }
      )}
      onClick={() => !leg.noSeatSelection && !isSelected && onSelect(leg.id)}
    >
      <Radio value={leg.id} isDisabled={leg.noSeatSelection} className="mr-3" />
      <div className="flex flex-1 flex-col">
        <div className="flex items-center gap-1">
          <Typography
            variant="body2-bold"
            className={cn('max-w-[120px] truncate text-dark', {
              'text-neutral': leg.noSeatSelection,
            })}
          >
            {leg.origin}
          </Typography>
          <Icons.oneWay width={12} height={12} className="text-neutral" />
          <Typography
            variant="body2-bold"
            className={cn('max-w-[120px] truncate text-dark', {
              'text-neutral': leg.noSeatSelection,
            })}
          >
            {leg.destination}
          </Typography>
        </div>
        <div className="flex items-center justify-between">
          <Typography variant="label" className="text-neutral">
            <span className="font-bold">
              <TransText i18nKey="leg" /> {leg.legNumber}
              {': '}
            </span>
            {leg.direction && <TransText i18nKey={leg.direction} />}
            {leg.noSeatSelection && (
              <>
                {', '}
                <TransText i18nKey="noSeatSelectionAvailable" />
              </>
            )}
          </Typography>
        </div>
      </div>
      {leg.noSeatSelection ? (
        <Icons.stop className="text-neutral" width={20} height={20} />
      ) : (
        <TransportationTypeIcon ptMode={leg.ptMode} className="text-dark" />
      )}
    </div>
  );
};
